var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecheDR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,640.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.2,6256.3l-38.3-34.6l-43.1-34.9c-26.7-21.8-43.8-36-45-37.6c-4.4-5.6-6.2-11.2-6.3-18.5 c-0.1-8.5,2.9-15.5,9-21.6c9.6-9.6,24.2-11.6,36.2-5.1c5.2,2.8,162.1,130.1,164.8,133.7c9.4,12.4,8.5,29.1-2.2,39.7 c-2.4,2.4-18.2,14-47.9,35.1c-24.3,17.3-60.4,43-80.2,57.1c-19.8,14.1-37.5,26.4-39.3,27.3c-1.8,1-4.9,2.1-6.9,2.5 c-4.3,1-11.8,0.7-15.8-0.4c-6.7-2-12.8-6.8-16.9-13c-7.5-11.4-5.8-27.5,3.9-37.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheDR);
export default __webpack_public_path__ + "static/media/fleche_d_r.ac0c723154722baf0918974d45d1e083.svg";
export { ForwardRef as ReactComponent };